module.exports = __webpack_public_path__ + "img/slotmachine.3e657744.png";